import React from 'react';
import './schedule-pickup.css';
import Modal, { IModalChildProps } from '../../common/modal';
import { IUPSPickupRequest } from '../../../models/ups-pickup-request';
import { WrappedComponentProps, useIntl } from 'react-intl';

interface IScheduleUPSPickupThankYou extends IModalChildProps {
    upsPickupRequest: IUPSPickupRequest;
    isNuEar: boolean;
}

export const ScheduleUPSPickupThankYou = ({
    upsPickupRequest,
    onAccept,
    onClose,
    isNuEar,
}: IScheduleUPSPickupThankYou) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="well">
                    <div className="row">
                        <div className="col-sm-10">
                            <h1 className={isNuEar ? 'nuEar' : 'starkey'}>
                                YOUR UPS PICKUP REQUEST HAS BEEN SUBMITTED
                            </h1>
                        </div>
                        <div className="col-sm-2 no-print">
                            <button
                                className="pull-right"
                                onClick={() => window.print()}
                                style={{ paddingTop: '4px' }}
                            >
                                &#128438;&nbsp;Print
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <span>Thank you for scheduling a UPS pickup.</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <span>Your UPS confirmation number is: </span>
                            <span className="text-primary">
                                {upsPickupRequest.prn}
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            {intl.formatMessage(
                                {
                                    id: 'You_Have_UPS_Pickup_On',
                                    defaultMessage:
                                        'You have requested a UPS Pickup on {0}, between {1} and {2}.',
                                },
                                {
                                    0: upsPickupRequest!.pickupDate!.toLocaleDateString(),
                                    1: upsPickupRequest!.pickupMinTime!.toLocaleTimeString(
                                        [],
                                        {
                                            hour: 'numeric',
                                            minute: '2-digit',
                                        }
                                    ),
                                    2: upsPickupRequest!.pickupMaxTime!.toLocaleTimeString(
                                        [],
                                        {
                                            hour: 'numeric',
                                            minute: '2-digit',
                                        }
                                    ),
                                }
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal-footer no-print">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default ScheduleUPSPickupThankYou;
